import React, { Fragment } from "react";
import { Label, Input, Form, Row, Col } from "reactstrap";
import { useQuery } from "@apollo/client";
import { GET_ALL_COUNTRIES } from "../../../queries";
import { Multiselect } from "react-widgets";
import { useSupporterSignUpContext } from "../context/SupporterStatusContext";

const Step2 = ({ update }) => {
  const { loading, error, data: formOptions } = useQuery(GET_ALL_COUNTRIES);
  const { state, dispatch } = useSupporterSignUpContext();

  return (
    <Fragment>
      <div className="form-wizard-content">
        <Form>
          <Row
            style={{
              marginBottom: "20px",
            }}
          >
            <Col xs={12} md={3}>
              関心のある課題分野
            </Col>
            <Col xs={12} md={9}>
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  marginLeft: "20px",
                }}
              >
                {formOptions?.allActivityfields?.edges?.map((activity) => {
                  return (
                    <Label
                      key={activity.node.id}
                      check
                      style={{
                        marginRight: "36px",
                        marginBottom: "8px",
                      }}
                    >
                      <Input
                        type="checkbox"
                        defaultChecked={state.interestingActivity.includes(
                          update ? activity.node.id : activity.node.intId
                        )}
                        name="interestingActivity"
                        value={update ? activity.node.id : activity.node.intId}
                        onChange={(e) => {
                          dispatch({
                            type: "HANDLE_CHECKBOX_CHANGE",
                            payload: {
                              name: "interestingActivity",
                              value: update
                                ? activity.node.id
                                : activity.node.intId,
                              checked: e.target.checked,
                            },
                          });
                        }}
                      />{" "}
                      {activity.node.name}
                    </Label>
                  );
                })}
              </div>
            </Col>
          </Row>
          <Row>
            <Col xs={12} md={3}>
              関心のある地域・国
            </Col>
            <Col xs={12} md={9}>
              <Multiselect
                data={formOptions?.countries?.edges?.map((country) => ({
                  id: country.node.intId,
                  nameJp: country.node.nameJp,
                }))}
                placeholder={`国を選択  `}
                dataKey="id"
                textField="nameJp"
                defaultValue={state["interestingCountry"]}
                onChange={(e) => {
                  dispatch({
                    type: "HANDLE_CHANGE",
                    payload: {
                      name: "interestingCountry",
                      value: e,
                    },
                  });
                }}
              />
            </Col>
          </Row>
        </Form>
      </div>
    </Fragment>
  );
};

export default Step2;
